import React from 'react'
import PropTypes from 'prop-types'
import ModalComp from '../../Layouts/Modal'
import ViewImageOrPDF from '../../Layouts/ViewImageOrPDF'
import { hookPaginationPropType, hookPreviewType } from '../../../data/propTypes'

const ShowFile = ({ onClose, hookPreview, hookVouchers }) => {
    const { file_name } = hookVouchers.dataSel;
    return (
        <ModalComp
            onClose={onClose}
            keyboard
            title={file_name}
            size='lg'
            body={
                <div style={{ width: '100%' }}>
                    {
                        hookPreview.blobFile &&
                        <ViewImageOrPDF
                            file={hookPreview.blobFile}
                            loading={hookPreview.loading}
                        />
                    }
                </div>
            }
        />
    )
}

ShowFile.propTypes = {
    onClose: PropTypes.func.isRequired,
    hookPreview: hookPreviewType,
    hookVouchers: hookPaginationPropType
}

export default ShowFile